(function () {
	const initFeaturedBlogSwiper = () => {
		document.querySelectorAll(".js-featured-blog-swiper").forEach((swiperEl) => {
			if (swiperEl.classList.contains("swiper-initialized")) return;

			const columns = parseInt(swiperEl.dataset.columns, 10) || 4;
			const scrollbar = swiperEl.parentElement.querySelector(".js-featured-blog-scrollbar");

			new Swiper(swiperEl, {
				slidesPerView: 1.2,
				spaceBetween: 16,
				scrollbar: scrollbar
					? {
							el: scrollbar,
							draggable: true,
					  }
					: false,
				breakpoints: {
					750: {
						slidesPerView: columns,
						spaceBetween: 24,
					},
				},
			});
		});
	};

	document.addEventListener("DOMContentLoaded", initFeaturedBlogSwiper);
	document.addEventListener("shopify:section:load", initFeaturedBlogSwiper);
})();
